import { useContracts } from 'components/contracts/useContracts';
import { useTranslation } from 'react-i18next';
import React from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { PostboxTabs } from './PostboxTabs';
import { withLoadingAndNoConnectionHandler } from 'components/integration-wrapper';
import { PostboxLocationState } from './PostboxLocationState';

const PostboxTabsWithHandlers = withLoadingAndNoConnectionHandler(PostboxTabs);

export const PostboxWrapper: React.FC = () => {
    const { t } = useTranslation('postbox');
    const { data: contracts, isLoading: isLoadingContracts, loadingError: loadingErrorContracts } = useContracts();
    const { contractId } = useParams<{ contractId?: string }>();
    const { state: locationState } = useLocation<PostboxLocationState | undefined>();

    return (
        <>
            <h2>{t('sub-headline')}</h2>
            <p>{t('description')}</p>
            <PostboxTabsWithHandlers
                isLoading={isLoadingContracts}
                hasError={!!loadingErrorContracts}
                contracts={contracts || []}
                initialContractNumber={contractId}
                filterToInvoices={locationState?.filterToInvoices}
                initialTimeframe={locationState?.timeframeFilter}
            />
        </>
    );
};
